var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_84",
    "data-name": "Layer 84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,10.5A21.52,21.52,0,0,0,10.5,32c1.18,28.52,41.82,28.51,43,0A21.52,21.52,0,0,0,32,10.5Zm0,40A18.52,18.52,0,0,1,13.5,32c1-24.54,36-24.54,37,0A18.52,18.52,0,0,1,32,50.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,36.61a1.5,1.5,0,0,0,1.5-1.5v-12a1.5,1.5,0,0,0-3,0v12A1.5,1.5,0,0,0,32,36.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,38.7a1.59,1.59,0,0,0,0,3.18A1.59,1.59,0,0,0,32,38.7Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmber);
export default __webpack_public_path__ + "static/media/amber.da9c037a88e5783e6fadab9930690142.svg";
export { ForwardRef as ReactComponent };